import {ApiEngine} from "api-engine";
import React from "react";
import User from "../../../models/User";

export const ApiContext = React.createContext({
    api: null as ApiEngine | null,
    user: null as User | null
});
